import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import {
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  TableContainer,
  Paper,
  Alert,
  Box,
  CircularProgress,
  Pagination,
} from "@mui/material";
import { TypographyNormal } from "../../../../components/customComponent";

import TrainDisruptionItem from "./TrainDisruptionItem";
import {
  getDisruption,
  getLines,
} from "../../../store/actions/smrt/disruptionAction";
import { usePagination } from "../../../../components/hooks";
import { useTranslation } from "react-i18next";

const TrainDisruptionList = () => {
  const { t } = useTranslation("smrtDisruption");
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(getDisruption());
    dispatch(getLines());
  }, [dispatch]);

  const { disruptions, loadingDisruption } = useSelector(
    (state) => state.smrtDisruption
  );

  const [page, setPage] = useState(1);

  const DATA_PER_PAGE = 5;

  const count = Math.ceil(disruptions.length / DATA_PER_PAGE);

  const _DATA = usePagination(disruptions, DATA_PER_PAGE);

  const handleChangePagination = (e, page) => {
    setPage(page);
    _DATA.jump(page);
  };

  if (loadingDisruption)
    return (
      <Box
        sx={{ height: "20vh" }}
        display="flex"
        justifyContent="center"
        alignItems="center"
        flexDirection="column"
      >
        <CircularProgress size={20} thickness={3} sx={{ color: "#1D4ED8" }} />
        <TypographyNormal sx={{ color: "#1D4ED8", mt: 2, fontWeight: 300 }}>
          {t("loadingData")}
        </TypographyNormal>
      </Box>
    );

  return (
    <>
      {!disruptions.length || disruptions === undefined ? (
        <Alert severity="info" variant="filled">
          <strong>{t("noDisruption")}</strong>
        </Alert>
      ) : (
        <TableContainer
          component={Paper}
          sx={{ overflowY: "auto", maxHeight: 500, boxShadow: 3 }}
        >
          <Table>
            <TableHead>
              <TableRow>
                <TableCell></TableCell>
                <TableCell>{t("table.type")}</TableCell>
                <TableCell>{t("table.line")}</TableCell>
                <TableCell>{t("table.fromStation")}</TableCell>
                <TableCell>{t("table.direction")}</TableCell>
                <TableCell>{t("table.toStation")}</TableCell>
                <TableCell>{t("table.affectedStation")}</TableCell>
                <TableCell>{t("table.resume")}</TableCell>
                <TableCell>{t("table.createdAt")}</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {disruptions &&
                _DATA
                  .currentData()
                  .map((disruption) => (
                    <TrainDisruptionItem
                      key={disruption.id}
                      disruption={disruption}
                    />
                  ))}
            </TableBody>
          </Table>
        </TableContainer>
      )}

      {!loadingDisruption && disruptions.length ? (
        <Box
          sx={{
            display: "flex",
            justifyContent: "flex-end",
            pt: 4,
            pb: 2,
            pr: 2,
          }}
        >
          <Pagination
            count={count}
            page={page}
            shape="rounded"
            color="primary"
            onChange={handleChangePagination}
          />
        </Box>
      ) : null}
    </>
  );
};

export default TrainDisruptionList;
